import React, { useState } from 'react';
import { Modal } from '../common/Modal';
import { OrganizerForm } from './forms/OrganizerForm';
import { useOrganizersStore } from '../../stores/organizersStore';
import { Organizer } from '../../types/organizer';
import toast from 'react-hot-toast';
import { useLanguage } from '../../contexts/LanguageContext';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  organizer: Organizer;
};

export const EditOrganizerModal = ({ isOpen, onClose, organizer }: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const { updateOrganizer } = useOrganizersStore();
  const { translations } = useLanguage();

  const handleSubmit = async (data: Partial<Organizer>) => {
    if (!data.name) {
      setError(
        translations?.editOrganizerModal?.requiredFieldsError ||
          'Name is required'
      );
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      await updateOrganizer(organizer.id, {
        ...data,
        updatedAt: Date.now(),
      });
      toast.success(
        translations?.editOrganizerModal?.updateSuccess ||
          'Organizer updated successfully'
      );
      onClose();
    } catch (err: any) {
      setError(
        err.message ||
          translations?.editOrganizerModal?.updateError ||
          'Failed to update organizer'
      );
      toast.error(
        translations?.editOrganizerModal?.updateError ||
          'Failed to update organizer'
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={translations?.editOrganizerModal?.title || 'Edit Organizer'}
    >
      {error && (
        <div className="mb-4 p-3 bg-red-50 text-red-600 rounded-lg text-sm">
          {error}
        </div>
      )}
      <OrganizerForm
        onSubmit={handleSubmit}
        initialData={organizer}
        isLoading={isLoading}
        isEditing
      />
    </Modal>
  );
};